import { useState, useEffect } from 'react';

const useIsMounted = () => {
    const [isMounted, setIsMounted] = useState(false);
    useEffect(() => {
        setIsMounted(true);
    }, []);
    return isMounted;
};

export { useIsMounted as u };
//# sourceMappingURL=hook-Bex3s64q.js.map
